import { Frequency, OptionalFrequency } from 'shared/interfaces/Commute'

/**
 * Returns the initial frequency configuration for a second frequency based
 * on an initial frequency passed in parameter. If the user chose set days
 * then, for now, we force him to choose set days again in the second frequency choice.
 * For that we use the days attribute to know if it is set days or not.
 *
 * If it is not set days we initiate the frequency id (weekly of monthly)
 * to be the same as the origin frequency passed in param
 *
 * @param frequency - The frequency to infer the initial value from
 */
export const inferFrequencyInitialValueFrom = (
  frequency: Frequency | undefined,
  options?: { presetDays: boolean }
): OptionalFrequency => {
  if (!frequency) {
    return
  }
  return {
    // We use the days attribute to know if it is set days or not
    days: frequency.days ? (options?.presetDays ? frequency.days : []) : undefined,
    weeklyFrequency: options?.presetDays ? frequency.weeklyFrequency : 0
  }
}
